import { mapState, mapGetters, mapActions } from 'vuex'
import GraphComponents from '../graph/components'
import formatDate from '@/module/util/format-date'
import formatDateTime from '@/module/util/format-date-time'
import fomatDateTimeFull from '@/module/util/fomat-date-time-full'
import formatTime from '@/module/util/format-time'

export default {
	props: {
		patient: {
			type: Object,
			required: true
		},
		isSurvey: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		formatDate,
		formatDateTime,
		formatTime,
		fomatDateTimeFull,

		getIconImage(card) {
			return require('./image/' + card + '.png')
		},
		getProfileFromProvider(providerId) {
			if(this.patient.profile_map) {
				const providerProfile = this.patient.profile_map.find((providerProfile) => providerProfile.includes(providerId))
				if(providerProfile)
					return '(' + this.getContentKey('profile', providerProfile.split(':')[1], 'title') + ')'
			}
			else
				return '(' + this.getContentKey('profile', this.patient.profile[0], 'title') + ')'

		},
		...mapActions('content', [
			'loadContent',
		]),
		...mapActions('provider', [
			'loadPatientChart'
		])
	},

	computed: {
		...mapGetters('content', [
			'getContent',
			'getContentKey'
		]),
		...mapGetters('provider', [
			'getProvider',
			'getCurrentProvider',
			'allPatientsChosen',
			'getProvidersIdArray',
			'getPatientEvents',
			'getPatientProviderProfileList'
		]),
		patientProviderProfileList() {
			return this.getPatientProviderProfileList(this.patient.id)
		},
		provider() {
			return this.getProvider
		},
		providerProfiles() {
			if (this.getProvider)
				return this.getProvider.profile
			return []
		},
		showMultiProviders() {
			return this.allPatientsChosen && (this.patientProviderProfileList.length > 1)
		},
		patientEvents() {
			return this.getPatientEvents(this.patient.id)
		},
		/**
		 * Gets patient events by type
		 *
		 * @returns
		 */
		patientEventType() {
			/**
			 * List of types which get filtered by provider id
			 */
			const typeFilterByProvider = ['questionnaire', 'checklist', 'appointment']
			return (type) => { 
				return this.patientEvents.filter((event) => {
					if(type === 'questionnaire') {
						if(this.isSurvey && !event.provider_survey)
							return false
						else if(!this.isSurvey && event.provider_survey)
							return true
					}
					
					if(typeFilterByProvider.includes(type) && (this.allPatientsChosen ? !this.getProvidersIdArray.includes(event.provider) : (event.provider !== this.getCurrentProvider)))
						return false
					return event.type && event.type.startsWith(type)
				})
			}
		}
	}
}
